import { render, staticRenderFns } from "./TransactionCategoryList.vue?vue&type=template&id=a9efc4d2"
import script from "../../../controllers/custom/transaction_category/transaction-category-list.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/transaction_category/transaction-category-list.js?vue&type=script&lang=js&external"
import style0 from "./TransactionCategoryList.vue?vue&type=style&index=0&id=a9efc4d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports